import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Col, Row, Label, FormText,
} from 'reactstrap';
import * as Actions from '../../actions/campEntryActions';
import PriceRow from './PriceRow';
import { splitByThousands } from '../../helpers/helper';
import { Prices } from '../../helpers/propTypes';

class View extends PureComponent {
  componentDidMount() {
    if (this.props.initializePrice) {
      this.props.getPrices();
    }
  }

  render() {
    const {
      prices, isFree, freeMessage, displays, notice,
    } = this.props;

    const details = !$.isEmptyObject(prices) ? prices.details : null;
    const priceNames = {
      basePrice: '基本料金',
      pcRentalFee: 'PCレンタル代',
      rentalPrices: 'レンタル代',
      travelCost: '宿泊費',
    };

    const discountNames = {
      couponDiscount: 'クーポン割引',
      preentryDiscount: 'プレエントリー割引',
      paymentDiscount: '支払方法割引',
    };

    return (
      <>
        <Label className="font-weight-bold">お支払い金額</Label>
        {displays && displays.camp_id === 214 && (
          <FormText color="muted">
            基本料金には3泊4日の食事・宿泊費を含みます
          </FormText>
        )}
        <div className="price">
          {!isFree && details != null ? (
            <>
              <Row>
                <Col sm={5} xs={3}>内訳</Col>
                <Col sm={7} xs={9}>
                  <>
                    {Object.keys(priceNames).map((key) => (
                      key === 'rentalPrices' ? (
                        details.rentalPrices.rentals.length > 0 && details.rentalPrices.rentals.map((rental) => (
                          <PriceRow key={rental.name} price={rental.price} name={`${rental.name}${priceNames.rentalPrices}`} />
                        ))
                      ) : <PriceRow key={key} price={details[key]} name={priceNames[key]} />
                    ))}
                    {Object.keys(discountNames).map((key) => (
                      <PriceRow key={key} price={details[key]} name={discountNames[key]} />
                    ))}
                    {Array.isArray(details.earlyDiscounts) && details.earlyDiscounts.length > 0
                      ? details.earlyDiscounts.map((d, i) => (
                        <PriceRow key={`earlyDiscount-${i}`} price={d.amount} name={d.name} />
                      ))
                      : <PriceRow key="earlyDiscount" price={details.earlyDiscount} name="自動割引" />}
                  </>
                </Col>
              </Row>
              <hr />
            </>
          ) : null}
          {!isFree && (
            <p className="pre-tax text-right">
              税別
              {!$.isEmptyObject(prices) ? splitByThousands(prices.priceBeforeTax) : ' - '}
              円
            </p>
          )}
          <Row>
            <Col className="total">合計金額</Col>
            <Col className="total-price text-right">
              税込
              <span>
                {(() => {
                  if (isFree) return 0;
                  return !$.isEmptyObject(prices) ? splitByThousands(prices.price) : ' - ';
                })()}
              </span>
              円
            </Col>
          </Row>
          { isFree && (<FormText color="danger" style={{ fontSize: '14px' }}>{freeMessage}</FormText>)}
          { notice && (<FormText color="danger" style={{ fontSize: '14px' }}>{notice}</FormText>)}
        </div>
      </>
    );
  }
}

View.defaultProps = {
  isFree: false,
  freeMessage: null,
  initializePrice: false,
  displays: null,
  notice: null,
};

View.propTypes = {
  prices: Prices.isRequired,
  isFree: PropTypes.bool,
  freeMessage: PropTypes.string,
  initializePrice: PropTypes.bool,
  getPrices: PropTypes.func.isRequired,
  displays: PropTypes.shape({
    camp_id: PropTypes.number,
  }),
  notice: PropTypes.string,
};

export default connect((state) => ({
  prices: state.campEntry.prices,
}), (dispatch) => ({
  getPrices: () => dispatch({
    type: Actions.SAGA_GET_PRICES,
  }),
}))(View);
